import {
  Component,
  OnInit,
  ElementRef,
  ViewChildren,
  QueryList,
} from "@angular/core";
import {
  Router,
  NavigationEnd,
  NavigationStart,
  ActivatedRoute,
} from "@angular/router";
import { UserService } from "src/app/shared/user.service";
import { LoggerService } from "src/app/services/Non-Master/logger.service";
import { tFormMappingService } from "src/app/services/tFormMapping.service";
import {
  FormMappingFormModel,
  NavFormMappingInfoWithImageModel,
} from "src/app/models/tFormMappingModel";
import { tShopService } from "src/app/services/tShop.service";
import { AppSettings } from "src/app/shared/AppSettings";
import { AppComponent } from "src/app/app.component";
import { FIND_tFormID } from "src/app/models/tFormModel";
import {
  tVerModel,
  currentVerInfoID,
} from "src/app/models/non-master-model/tVerModel";
import { tVerService } from "src/app/services/Non-Master/tVer.service";
import { tShopModel } from "src/app/Models/tShopModel";
import * as jwt_decode from "jwt-decode";
import { TokenModel } from "src/app/models/token-model/tokenModel";
import { MastersKeyStringValue } from "src/app/services/Non-Master/MastersKeyStringValue.service";
import { TranslateService } from "@ngx-translate/core";
import { ApiResultDialogService } from "src/app/services/Non-Master/ApiResultDialog.service";
import { finalize } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import * as _moment from 'moment';
import { isNullOrUndefined } from "util";

const moment = _moment;
@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.css"],
})
export class NavigationComponent implements OnInit {

  constructor(
    private router: Router,
    private service: UserService,
    private tVerService: tVerService,
    private log: LoggerService,
    private tFormMappingService: tFormMappingService,
    private tShopService: tShopService,
    private translate: TranslateService,
    private apiResultDialogService: ApiResultDialogService,
    public route: ActivatedRoute,
  ) {
    const currentLanguage = localStorage.getItem("currentLanguage");
    translate.use(currentLanguage);
  }
  public static selectedShopID = 1;
  public static currentLanguage: string;

  public static selectedDisplay_shopName: string;
  public static userID: string;
  public static EmployeeRoleID: number;

  showEnglish = false;

  public display_Language: string;

  //tFormMapping: NavFormMappingInfoModel[];
  static formMapping: NavFormMappingInfoWithImageModel[] = new Array();

  TAG = "NavigationComponent";
  shopList: tShopModel[];
  public static shopListGlobal: tShopModel[];
  usingShopID = 1;

  tVerModel: tVerModel = new tVerModel();

  display_userName: string;
  display_shopName: string;

  public static billpayReceiptCert_isPackageAmountAfterDiscount: boolean =
    false;
  public static billpayReceiptCert_isItemAmountAfterDiscount: boolean = false;

  //counterStart = 60 * 60; //120 Minute Idle and Logout
  public counterStart = 10; // Test, 5 Second Idle and Logout
  public counter = this.counterStart;

  public idleTimer;
  public refreshTokenTimer;

  countScanToken = 0;

  @ViewChildren("navList") navList: QueryList<any>;

  isMenuCollapsed = true;

  ngOnInit() {
    this.initTokenInfo();
    NavigationComponent.currentLanguage = AppComponent.usingLanguage;

    this.display_Language = NavigationComponent.currentLanguage;
    this.setLang(this.display_Language);

    // init data

    // Get Version
    this.tVerService.getInfoByID(currentVerInfoID.id).subscribe((data) => {
      this.tVerModel = data;
    });

     //get idleLogoutTime
    this.tShopService.getDataById(this.usingShopID.toString()).subscribe((data) => {

      this.counterStart = data.idleLogoutMinutes * 60;
      this.counter = data.idleLogoutMinutes * 60;
    });

    //this.doTimer();

    this.router.events.subscribe((e) => {
      // console.log('router change :'+e);
      if (e instanceof NavigationStart) {
        this.counter = this.counterStart;
      }

      if (e instanceof NavigationEnd) {
        this.counter = this.counterStart;
        if(e.url == '/login') {this.pauseTimer(); this.stopRefreshTokenTimer();}
      }
    });
  }

  setLang(lang: string) {
    console.log("lang " + lang);
    this.showEnglish = lang === "zh-TW"? false:true;
    localStorage.setItem("currentLanguage", lang);
    this.translate.use(lang);
  }

  static SetNavBarSelectedForm(targetFormNumber: number) {
    // console.log("do SetNavBarSelectedForm targetFormNumber = " + targetFormNumber);
    var model = NavigationComponent.FindTargetFormIDModel(
      NavigationComponent.formMapping,
      targetFormNumber
    );
    if (model != null) {
      NavigationComponent.SetNavBarShowing(
        NavigationComponent.formMapping,
        model
      );
    }
  }

  pauseTimer(){
    clearInterval(this.idleTimer);
  }

  restartToken(){
    this.pauseTimer();
  }

  stopRefreshTokenTimer(){
    clearInterval(this.refreshTokenTimer);
    this.countScanToken = 0;
  }

  setRefreshTokenTimer(){
    this.refreshTokenTimer = setInterval(() => {
      this.countScanToken++;
      console.log('countScanToken = '+this.countScanToken);
      //exp < now -> logout
      if(localStorage.getItem("token") != null){
        const tokenInfo = this.getDecodedAccessToken(
          localStorage.getItem("token")
        ); // decode token
        const token: TokenModel = tokenInfo;

        let now:Date = new Date();
        let exp = new Date(token.exp * 1000);
        //console.log('@13 old exp = '+token.exp)
        console.log('@01 token exprie time = '+exp +' , now = '+now);


        if(exp < now) {
          console.log('token exprie time < now');
        }else if(exp == now){
          console.log('token exprie time == now');
        }else{
          console.log('token exprie time > now');
          let exp30 = moment(exp).subtract(30, 'm').toDate();
          if(exp30 > now){
            console.log('token exprie time + 30mins ='+exp30);
            console.log('token exprie time + 30mins > now');
          }else if(exp30 == now){
            console.log('token exprie time + 30mins == now');
          }
          else{
            console.log('@1001 token exprie time + 30mins < now');
            console.log('@1001 refresh token');
            this.refreshToken();
          }

        }


      }
    },5000);
  }

  doTimer() {
    console.log('call doTimer');
    this.idleTimer = setInterval(() => {
      this.counter = this.counter - 1;
      console.log('AutoLogoutTimer count = '+ this.counter);
      //this.log.i('AutoLogoutTimer', 'Counting ' + this.counter);
      if (this.counter === 0) {
        clearInterval(this.idleTimer);

        this.log.i('AutoLogoutTimer', 'Times Up ' + this.counter);

        let returnDisplayMsg = "";
        this.translate
          .get("Message_ForceLogout_idle")
          .subscribe((res: string) => {
            returnDisplayMsg = res;
            //  this.openAPI_Result_Modal(MastersKeyStringValue.ACTION_MessageDialog, returnDisplayMsg);
            //this.apiResultDialogService.openDialog(MastersKeyStringValue.ACTION_BillpayConfirmPackage, MastersKeyStringValue.TABLE_Journal, status, returnDisplayMsg);
            this.onLogout();
            const dialogRef = this.openDialog(
              MastersKeyStringValue.ACTION_MessageDialog,
              returnDisplayMsg
            );

            dialogRef.result.then(
              (result) => {
                // on this.activeModal.close('Y');
              },
              (reason) => {}
            );
          });
      }

    }, 1000);
  }

  openAPI_Result_Modal(status, msg) {
    this.apiResultDialogService.openDialog(status, "", status, msg);
  }

  openDialog(status, msg) {
    this.log.i(this.TAG, "openConfirmModal action = " + status);
    return this.apiResultDialogService.openDialog(status, "", status, msg);
  }

  refreshToken(){
    this.stopRefreshTokenTimer();

    this.service.changeShopID(this.usingShopID).subscribe(
      (res: any) => {
        localStorage.setItem("token", res.token);

        if (localStorage.getItem("token") != null) {
          this.setRefreshTokenTimer();
          console.log('new token = '+localStorage.getItem("token"));
        }
      },
      (err) => {
        console.log(err);
        this.log.e("", err);
      }
    );

  }

  onChangeShopID(shopID: number) {
    this.stopRefreshTokenTimer();

    this.service.changeShopID(shopID).subscribe(
      (res: any) => {
        console.log('changeShopID return token = '+res.token);
        localStorage.setItem("token", res.token);

        if (localStorage.getItem("token") != null) {
          const tokenInfo = this.getDecodedAccessToken(
            localStorage.getItem("token")
          ); // decode token

          const token: TokenModel = tokenInfo;
          NavigationComponent.userID = token.UserID;
          NavigationComponent.selectedShopID = Number(token.usingShopID);
          NavigationComponent.EmployeeRoleID = Number(token.employeeRoleID);
          this.usingShopID = NavigationComponent.selectedShopID;
          this.display_shopName = NavigationComponent.shopListGlobal.find(
            (item) => item.shopID == this.usingShopID
          ).shopName;
          NavigationComponent.selectedDisplay_shopName = this.display_shopName;
          this.display_userName = token.employeeName;

          // this.log.d(this.TAG, 'tokenInfo = ' + JSON.stringify(tokenInfo) + ' ,  NavigationComponent.selectedShopID = ' + NavigationComponent.selectedShopID
          //   + ' , NavigationComponent.EmployeeRoleID = ' + NavigationComponent.EmployeeRoleID); // show decoded token object in console

          this.display_shopName = NavigationComponent.shopListGlobal.find(
            (item) => item.shopID == this.usingShopID
          ).shopName;

          this.initShopList();
        } else {
          this.initShopList();
        }

        //don't put  this.initShopList(); here ,avoid do  this.initShopList(); first.
        //It will become wrong token
      },
      (err) => {
        console.log(err);
        this.log.e("", err);
      }
    );

    // reload to home page
    this.initNavigationBar();
    this.router.navigate(["/main/home"]);
  }

  initShopList() {
    this.tShopService.getAllData().subscribe(
      (res) => {
        this.shopList = res;
        NavigationComponent.shopListGlobal = res;
        this.initNavigationBar();

        this.display_shopName = NavigationComponent.shopListGlobal.find(
          (item) => item.shopID == this.usingShopID
        ).shopName;
        NavigationComponent.selectedDisplay_shopName = this.display_shopName;

        // make down billpay receipt config
        var shopConfigRemark = NavigationComponent.shopListGlobal.find(
          (item) => item.shopID == this.usingShopID
        ).shopRemark;
        this.log.i(this.TAG, "shopConfigRemark = " + shopConfigRemark);

        var shopConfigRemarkJson = isNullOrUndefined(shopConfigRemark)? '':JSON.parse(shopConfigRemark);

        NavigationComponent.billpayReceiptCert_isPackageAmountAfterDiscount =
          shopConfigRemarkJson.BillpayReceiptCert_isPackageAmountAfterDiscount;
        NavigationComponent.billpayReceiptCert_isItemAmountAfterDiscount =
          shopConfigRemarkJson.BillpayReceiptCert_isItemAmountAfterDiscount;

        this.log.i(
          this.TAG,
          "shopConfigRemarkJson = " +
            shopConfigRemarkJson +
            " , NavigationComponent.billpayReceiptCert_isPackageAmountAfterDiscount = " +
            NavigationComponent.billpayReceiptCert_isPackageAmountAfterDiscount +
            " , NavigationComponent.billpayReceiptCert_isItemAmountAfterDiscount = " +
            NavigationComponent.billpayReceiptCert_isItemAmountAfterDiscount
        );
        //this.setRefreshTokenTimer();
      },
      (err) => {
        // console.log(err);
        this.log.e(this.TAG, err);
      }
    );
  }
  ngAfterViewInit() {
    console.warn('call ngAfterViewInit')
    this.navList.changes.subscribe((t) => {
      this.ngForRendred();
    });
  }

  ngForRendred() {
    this.reloadNavBarColor();
  }

  initTokenInfo() {
    if (localStorage.getItem("token") != null) {
      const tokenInfo = this.getDecodedAccessToken(
        localStorage.getItem("token")
      ); // decode token
      const token: TokenModel = tokenInfo;
      NavigationComponent.selectedShopID = Number(token.usingShopID);
      NavigationComponent.EmployeeRoleID = Number(token.employeeRoleID);
      NavigationComponent.userID = token.UserID;
      this.display_userName = token.employeeName;

      this.usingShopID = NavigationComponent.selectedShopID;

      // this.log.d(this.TAG, 'tokenInfo = ' + JSON.stringify(tokenInfo) + ' ,  NavigationComponent.selectedShopID = ' + NavigationComponent.selectedShopID
      //   + ' , NavigationComponent.EmployeeRoleID = ' + NavigationComponent.EmployeeRoleID); // show decoded token object in console

      this.initShopList();
    }
  }

  getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch (Error) {
      return null;
    }
  }

  initNavigationBar() {
    // reload
    this.tFormMappingService
      .FormMappingNavigation(
        NavigationComponent.selectedShopID,
        NavigationComponent.EmployeeRoleID
      )
      .subscribe(
        (res) => {
          NavigationComponent.formMapping = res;
          //  this.log.i(this.TAG, "tFormMapping = " + JSON.stringify(res));
        },
        (err) => {
          console.log(err);
          this.log.e("", err);
        }
      );
  }

  reloadNavBarColor() {
    try {
      var selectedFormID = this.route.snapshot.firstChild.firstChild.data["id"];
      this.log.i(this.TAG, "do reloadNavBarColor = " + selectedFormID);
      NavigationComponent.SetNavBarSelectedForm(selectedFormID);
    } catch (error) {
      console.error(error);
    }
  }

  getFormMappingList() {
    return NavigationComponent.formMapping;
  }

  onLogout() {
    // this.router.navigate([AppSettings.Path_login]);
    //localStorage.removeItem('token');
    this.pauseTimer();

    this.service
      .logout(NavigationComponent.userID)
      .pipe(
        finalize(() => {
          console.log("Finally callback");
          this.router.navigate([AppSettings.Path_login]);
          localStorage.removeItem("token");
        })
      )
      .subscribe(
        (res: any) => {
          this.log.i(this.TAG, "successful logout");
        },
        (err) => {
          this.log.i(this.TAG, "logout error = " + err);
        }
      );
  }

  static FindTargetFormIDModel(
    formMappingList: NavFormMappingInfoWithImageModel[],
    formID: number
  ) {
    // var targetList = NavigationComponent.formMapping;
    for (let i = 0; i < formMappingList.length; i++) {
      for (let pp = 0; pp < formMappingList[i].formList.length; pp++) {
        if (formMappingList[i].formList[pp].formID == formID) {
          return formMappingList[i].formList[pp];
        }
      }
    }
  }

  static SetNavBarShowing(
    formMappingList: NavFormMappingInfoWithImageModel[],
    model: FormMappingFormModel
  ) {
    let element: any;
    for (let i = 0; i < formMappingList.length; i++) {

      for (let pp = 0; pp < formMappingList[i].formList.length; pp++) {


        try {
          element = document.getElementById(
            "submenuForm" + formMappingList[i].formList[pp].formID
          );
          if (element != null) {
            element.classList.remove("formIDSelected");
          }
        } catch (error) {
          console.error(error);
        }
      }
    }

    try {
      element = document.getElementById("submenuForm" + model.formID);
      if (element != null) {
        element.classList.add("formIDSelected");
      }


    } catch (error) {
      console.error(error);
    }
  }

  changePage(model: FormMappingFormModel) {
    this.log.i(
      this.TAG,
      "do changePage formID = " + model.formID + " " + model.formName
    );
    // this.setNavBarShowing(model);

    switch (model.formID) {
      case FIND_tFormID.tBed:
        // bed
        this.router.navigate([AppSettings.Path_bed]);
        break;
      case FIND_tFormID.tShop:
        this.router.navigate([AppSettings.Path_tShop]);
        break;
      case FIND_tFormID.tShopBldg:
        this.router.navigate([AppSettings.Path_tShopBldg]);
        break;

      // 2019.08.05 Marco Added for Book Aux. Master
      case FIND_tFormID.tBookAux:
        this.router.navigate([AppSettings.Path_tBookAux]);
        break;
      case FIND_tFormID.tPatientType:
        this.router.navigate([AppSettings.Path_tPatientType]);
        break;
      case FIND_tFormID.tPatient:
        localStorage.removeItem("systemMasterPatientID");
        this.router.navigate([AppSettings.Path_tPatient]);
        break;
      case FIND_tFormID.tEmployee:
        this.router.navigate([AppSettings.Path_tEmployee]);
        break;

      // 2019.07.17 Marco Added for Chinese Med. Master
      case FIND_tFormID.tMedicine:
        this.router.navigate([AppSettings.Path_tMedicine]);
        break;

      // 2019.07.17 Marco Added for Chinese Med. Master
      case FIND_tFormID.tVendor:
        this.router.navigate([AppSettings.Path_tVendor]);
        break;
      case FIND_tFormID.Booking:
        this.router.navigate([AppSettings.Path_Booking]);
        break;

      case FIND_tFormID.tChangeAcct:
        this.router.navigate([AppSettings.Path_tChangeAcct]);
        break;

      case FIND_tFormID.tItem:
        this.router.navigate([AppSettings.Path_tItem]);
        break;

      case FIND_tFormID.tItemCate:
        this.router.navigate([AppSettings.Path_tItemCate]);
        break;

      case FIND_tFormID.tPackage:
        this.router.navigate([AppSettings.Path_tPackage]);
        break;

      case FIND_tFormID.tPricebook:
        this.router.navigate([AppSettings.Path_tPriceBook]);
        break;

      case FIND_tFormID.tPayment:
        this.router.navigate([AppSettings.Path_tPayment]);
        break;

      case FIND_tFormID.tConsultHead_Waiting:
        this.router.navigate([AppSettings.Path_tConsultHead_Waiting]);
        break;

      case FIND_tFormID.tBookingArrive:
        this.router.navigate([AppSettings.Path_BookingArrive]);
        break;

      case FIND_tFormID.outstanding:
        this.router.navigate([AppSettings.Path_Outstanding]);
        break;

      case FIND_tFormID.billpayWalkIn:
        this.router.navigate([AppSettings.Path_BillPayWalkIn]);
        break;

      case FIND_tFormID.voidVoucher:
        this.router.navigate([AppSettings.Path_VoidVoucher]);
        break;

      case FIND_tFormID.patientHistory:
        this.router.navigate([AppSettings.Path_PatientHistory]);
        break;

      case FIND_tFormID.tGRN:
        this.router.navigate([AppSettings.Path_GRN]);
        break;

      case FIND_tFormID.inbound:
        this.router.navigate([AppSettings.Path_Inbound]);
        break;

      case FIND_tFormID.changePay:
        this.router.navigate([AppSettings.Path_changePay]);
        break;

      case FIND_tFormID.DayendReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_DayEndReport,
        ]);
        break;
        case FIND_tFormID.MonthSalesAnalysisReport:
          this.router.navigate([
        AppSettings.Path_Report + AppSettings.Path_MonthSalesAnalysisReport,
      ]);
          break;

      case FIND_tFormID.DayendDetailsReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_DayEndDetailsReport,
        ]);
        break;

      case FIND_tFormID.outbound:
        this.router.navigate([AppSettings.Path_Outbound]);
        break;

      case FIND_tFormID.PrescriptionList:
        this.router.navigate([AppSettings.Path_PrescriptionList]);
        break;

        case FIND_tFormID.PrescriptionPickList:
          this.router.navigate([AppSettings.Path_PrescriptionPickList]);
          break;
      case FIND_tFormID.Xray:
            this.router.navigate([AppSettings.Path_Xray]);
         break;
      case FIND_tFormID.Physio:
          this.router.navigate([AppSettings.Path_Physio]);
       break;
      case FIND_tFormID.loginUser:
        this.router.navigate([AppSettings.Path_LoginUser]);
        break;

      case FIND_tFormID.rolePermission:
        this.router.navigate([AppSettings.Path_UserPermission]);
        break;

      case FIND_tFormID.StockMovementReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_StockMovementReport,
        ]);
        break;

      case FIND_tFormID.StockOnHandReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_StockOnHandReport,
        ]);
        break;

      case FIND_tFormID.PackageRemainderReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_PackageRemainderReport,
        ]);
        break;

      case FIND_tFormID.voidVoucherBackDay:
        this.router.navigate([
          AppSettings.Path_VoidVoucher + AppSettings.Path_VoidVoucherBackDay,
        ]);
        break;

      case FIND_tFormID.BookingReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_BookingReviewReport,
        ]);
        break;

      case FIND_tFormID.EmployeeServiceReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_EmployeeServiceReport,
        ]);
        break;

      case FIND_tFormID.ChangeAccountReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_ChangeAccountReport,
        ]);
        break;

      case FIND_tFormID.VoidBillReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_VoidBillReport,
        ]);
        break;
        case FIND_tFormID.MonthSalesReportNewCases:
          this.router.navigate([
            AppSettings.Path_Report + AppSettings.Path_MonthSalesReportNewCases,
          ]);
          break;
      case FIND_tFormID.MonthSalesReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_MonthSalesReport,
        ]);
        break;
      case FIND_tFormID.SalesSummaryByDayReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_SalesSummaryByDayReport,
        ]);
        break;

      case FIND_tFormID.PatientSourceReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_PatientSourceReport,
        ]);
        break;

      case FIND_tFormID.warehouse:
        this.router.navigate([AppSettings.Path_Warehouse]);
        break;

      case FIND_tFormID.ConsultAssignRecords:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_ConsultAssignRecords,
        ]);
        break;

      case FIND_tFormID.accCurrencyMaster:
        this.router.navigate([
          AppSettings.Path_Acc + AppSettings.Path_Currency,
        ]);
        break;

      case FIND_tFormID.accRateMaster:
        this.router.navigate([AppSettings.Path_Acc + AppSettings.Path_Rate]);
        break;

      case FIND_tFormID.accChartAccMaster:
        this.router.navigate([
          AppSettings.Path_Acc + AppSettings.Path_ChartAccMaster,
        ]);
        break;

      case FIND_tFormID.accGLSetting:
        this.router.navigate([
          AppSettings.Path_Acc + AppSettings.Path_GLSetting,
        ]);
        break;

      case FIND_tFormID.accPeriod:
        this.router.navigate([
          AppSettings.Path_Acc + AppSettings.Path_AccPeriod,
        ]);
        break;

      case FIND_tFormID.accMonthEndClosing:
        this.router.navigate([
          AppSettings.Path_Acc + AppSettings.Path_AccMonthEndClosing,
        ]);
        break;

      case FIND_tFormID.ChartAccMonthEndPosting:
        this.router.navigate([AppSettings.Path_ChartAccMonthEndPosting]);
        break;

      case FIND_tFormID.AccPostingSetup:
        this.router.navigate([AppSettings.Path_AccPostingSetup]);
        break;

      case FIND_tFormID.journal:
        this.router.navigate([AppSettings.Path_Journal]);
        break;
      case FIND_tFormID.questionnaire:
        this.router.navigate([AppSettings.Path_Questionnaire]);
        break;

      case FIND_tFormID.analysisMaster:
        this.router.navigate([
          AppSettings.Path_Acc + AppSettings.Path_Analysis,
        ]);
        break;

      case FIND_tFormID.yearEnd:
        this.router.navigate([AppSettings.Path_Acc + AppSettings.Path_YearEnd]);
        break;

      case FIND_tFormID.ReportControl:
        this.router.navigate([AppSettings.Path_ReportControl]);
        break;

      case FIND_tFormID.EmployeeLeaveControl:
        this.router.navigate([AppSettings.Path_EmployeeLeave]);
        break;

      case FIND_tFormID.LoginManagement:
        this.router.navigate([AppSettings.Path_LoginManagement]);
        break;

      case FIND_tFormID.EmployeeServiceReport2:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_EmployeeServiceReport2,
        ]);
        break;

      case FIND_tFormID.PatientRecordsReport:
        //  this.router.navigate([AppSettings.Path_Report +AppSettings.Path_PatientRecordsReport]);
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_PatientRecordsReport,
        ]);
        break;

      case FIND_tFormID.CustomMasterReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_CustomMasterReport,
        ]);
        break;

      case FIND_tFormID.AnalysisReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_AnalysisReport,
        ]);
        break;

      case FIND_tFormID.GeneralLedgerReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_GeneralLedgerReport,
        ]);
        break;

      case FIND_tFormID.TrialBalanceReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_TrialBalanceReport,
        ]);
        break;
      case FIND_tFormID.itemCateReport:
          this.router.navigate([
            AppSettings.Path_Report + AppSettings.Path_itemCateSummary,
          ]);
          break;
      case FIND_tFormID.ProfitAndLossReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_ProfitAndLossReport,
        ]);
        break;
      case FIND_tFormID.BalanceSheetReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_BalanceSheetReport,
        ]);
        break;
      case FIND_tFormID.PaymentLedgerReport:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_PaymentLedgerReport,
        ]);
        break;
      case FIND_tFormID.MonthSalesReport2:
        this.router.navigate([
          AppSettings.Path_Report + AppSettings.Path_MonthSalesReport2,
        ]);
        break;
        case FIND_tFormID.MaterialOrderReport:
          this.router.navigate([
            AppSettings.Path_Report + AppSettings.Path_MaterialOrderReport,
          ]);
          break;
      case FIND_tFormID.mediTypeMaster:
          this.router.navigate([
            AppSettings.Path_MedicineType
          ]);
        break;
      case FIND_tFormID.tPurchaseOrder:
          this.router.navigate([
            AppSettings.Path_tPurchaseOrder,
        ]);
        break;
        case FIND_tFormID.historyByDate:
          this.router.navigate([
            AppSettings.Path_historyByDate,
        ]);
        break;
        case FIND_tFormID.dishesMaster:
          this.router.navigate([
            AppSettings.Path_dishesMaster,
        ]);
        break;
        case FIND_tFormID.materialCatMaster:
          this.router.navigate([
            AppSettings.Path_materialCatMaster,
        ]);
        break;
        case FIND_tFormID.materialMaster:
          this.router.navigate([
            AppSettings.Path_materialMaster,
        ]);
        break;
        case FIND_tFormID.materialList:
          this.router.navigate([
            AppSettings.Path_materialList,
        ]);
        break;
        case FIND_tFormID.dishesPlan:
          this.router.navigate([
            AppSettings.Path_dishesPlan,
        ]);
        break;
      case FIND_tFormID.batchNumberEnquiry:
          this.router.navigate([
            AppSettings.Path_BatchNumber,
          ]);
        break;

      case FIND_tFormID.ImportExportMaster:
        this.router.navigate([
          AppSettings.Path_ImportExportMaster,
        ]);
        break;

      case FIND_tFormID.copyPrescription:
        this.router.navigate([AppSettings.Path_copyPrescription]);
        break;

      case FIND_tFormID.DrugSpendingReport:
        this.router.navigate([
              AppSettings.Path_Report + AppSettings.Path_DrugSpendingReport,
            ]);
        break;
        case FIND_tFormID.GRNReport:
          this.router.navigate([
                AppSettings.Path_Report + AppSettings.Path_GrnReport,
              ]);
          break;

      default:
        break;
    }
  }
}
